import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AllDealStats, GetAllDealStatsPayload } from '../../../models/deal';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { getFunctionUrl } from 'src/app/utils/get-function-url';

@Injectable({
  providedIn: 'root',
})
export class GetAllDealStatsService {
  constructor(private http: HttpClient) {
  }

  get(payload: GetAllDealStatsPayload): Observable<AllDealStats> {
    // Todo: Create schema for single model
    return this.http.post<AllDealStats>(`${ getFunctionUrl(environment.urls.functions.v2, 'dealsapiv2') }/all-stats`, payload);
  }
}
